<template>
  <div class="app">
    <router-view v-slot="{ Component }">
      <keep-alive :exclude="state.exclude">
        <component :is="Component">
          <p>缓存页面</p>
        </component>
      </keep-alive>
    </router-view>
  </div>
</template>

<script>
import { reactive } from "vue";
import bus from "./utils/bus";
export default {
  name: "App",
  components: {},
  setup() {
    const state = reactive({
      exclude: [
        "register",
        "password",
        "search",
        "gamedetails",
        "gamecommentdatails",
        "tradesell",
        "traderevise",
        "tradedetails",
        "tradebuy",
        "center",
        "recharge",
        "goldexchange",
        "exchangerecord",
        "vip",
        "daily",
        "novice",
        "signin",
        "trygame",
        "trygamedetails",
        "trygamerecord",
        "rebate",
        "rebateapply",
        "rebaterecord",
        "mygame",
        "record",
        "feedback",
        "feedbackrecord",
        "couponcenter",
        "mycoupon",
        "collection",
        "recycle",
        "reminddetails",
        "recycleadd",
        "recyclerevise",
        "recyclerecord",
        "personalpage",
        "newsdetails",
        "mygift",
        "recycle-exchange",
        "web",
        "deduction",
        "web-activity",
        "groupdescdetail",
        "groupdesc",
        "chatgrouprule",
        "discountinvitedetail",
        "InviteFriend",
        "saving-card",
        "newgiftdetail",
        "newserviceChatAiqu",
        "newyunkefu"
      ],
    });
    document.addEventListener("visibilitychange", () => {
      if (document.hidden) {
        // Toast('挂起')
      } else {
        bus.emit("refreshcard");
      }
    });

    // 禁止页面放大
    window.onload = function() {
      document.addEventListener("touchstart", function(event) {
        if (event.touches.length > 1) {
          event.preventDefault();
        }
      });
      document.addEventListener("gesturestart", function(event) {
        event.preventDefault();
      });
    };

    return {
      state,
    };
  },
};

if (process.env.NODE_ENV !== "development") {
  // console.log("开发环境");
  window.console.log = function() {};
}
</script>

<style>
/* 	html,
	body {
		width: 100%;
		height: 100%;
		margin: 0;
		padding: 0;
		position: relative;
	} */

.app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
  /* -webkit-overflow-scrolling: touch; */
  /* 		width: 100%;
		height: 100%;
		overflow: scroll;
		-webkit-overflow-scrolling: touch;
		position: absolute;
		left: 0;
		top: 0; */
}

#nav {
  padding: 30px;
}

#nav a {
  font-weight: bold;
  color: #2c3e50;
}

#nav a.router-link-exact-active {
  color: #42b983;
}
</style>
